import Axios from "axios";

const GET_IP_ADDRESS =  "https://api.ipify.org/?format=json";

export const fetchIpAddress = () =>
  Axios({
    method: "GET",
    url: GET_IP_ADDRESS,
  });
